import styled from "@emotion/styled";
import classNames from "classnames";
import { PureComponent } from "react";
import { FieldRenderProps } from "react-final-form";

import { DesignToken } from "@livechat/design-system-react-components";

import { Icon, IconsEnum } from "components/icon/Icon";
import { withVar } from "themes/helpers";

const LockIcon = styled(Icon)`
  position: absolute;
  right: 0;
  bottom: 27px;
  fill: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => props.theme.primaryColor60
  };
`;

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/naming-convention
interface StyledContainerProps {
  size: "big" | "normal";
  disabled: boolean;
}

const StyledContainer = styled.fieldset<StyledContainerProps>`
  position: relative;
  max-width: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => (props.size === "big" ? "420px" : "300px")
  };
  font-size: 24px;
  padding: 10px 0 20px 0;

  input {
    border: 0;
    border-bottom: 1px solid ${withVar(DesignToken.BorderBasicPrimary)};
    width: 100%;
    font-size: ${
      // FIXME: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
      (props: any) => (props.size === "big" ? "24px" : "16px")
    };
    line-height: ${
      // FIXME: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
      (props: any) => (props.size === "big" ? "30px" : "22px")
    };
    text-align: center;
    outline: none;
    color: var(
      ${
        // FIXME: Fix this the next time the file is edited.
        // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
        (props: any) => (props.disabled ? DesignToken.ContentBasicDisabled : DesignToken.ContentBasicPrimary)
      }
    );
    background-color: transparent;
    transition: 0.3s all ease;
  }

  label {
    font-size: ${
      // FIXME: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
      (props: any) => (props.size === "big" ? "24px" : "16px")
    };
    pointer-events: none;
    position: absolute;
    top: ${
      // FIXME: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
      (props: any) => (props.size === "big" ? "10px" : "17px")
    };
    left: 0;
    transition: 0.3s all ease;
    text-align: center;
    width: 100%;
    color: ${
      // FIXME: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
      (props: any) => (props.disabled ? props.theme.primaryColor60 : props.theme.primaryColor80)
    };
    &.floated {
      top: 47px;
      font-size: 14px;
    }
  }

  &.has-error {
    input {
      border-bottom-color: ${withVar(DesignToken.BorderBasicNegative)};
    }
    label {
      color: ${withVar(DesignToken.ContentBasicNegative)};
    }
  }
`;

interface IProps extends FieldRenderProps<string, HTMLDivElement> {
  type?: "text" | "password" | "email";
  label: string;
  size?: "big" | "normal";
  disabled?: boolean;
  className?: string;
}

interface IState {
  focused: boolean;
}

export class FloatedInput extends PureComponent<IProps, IState> {
  state = {
    focused: false,
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  onFocus = (e: React.FocusEvent<HTMLInputElement>) => {
    this.setState({ focused: true });
    this.props.input.onFocus(e);
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  onBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    this.setState({ focused: false });
    this.props.input.onBlur(e);
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  render() {
    const { label, type, size, meta, input, disabled } = this.props;
    const { focused } = this.state;
    const err =
      (meta.submitFailed || (meta.touched && !meta.active)) && // condition
      (meta.error || (!meta.dirtySinceLastSubmit && meta.submitError)); // message retrieval
    return (
      <StyledContainer size={size || "normal"} disabled={!!disabled} className={classNames({ "has-error": err })}>
        <label className={classNames({ floated: focused || input.value || err })}>{err || label}</label>
        <input
          className={this.props.className}
          type={type || "text"}
          {...input}
          onFocus={this.onFocus}
          onBlur={this.onBlur}
          disabled={disabled}
          data-1p-ignore
          autoComplete="off"
        />
        {disabled && <LockIcon name={IconsEnum.ClosedLock} width="16px" height="16px" />}
      </StyledContainer>
    );
  }
}
